<script lang="ts">
  import type { ClassValue } from "svelte/elements";
  import type { FacetValueInput, FacetValueInputOptions } from "./type.ts";
  import inputDefault from "../facet-value/InputDefaultAction.ts";
  import { removeStatusIf, featureTrackingAttributes } from "../tracking";

  interface Props extends FacetValueInput, FacetValueInputOptions {
    id?: string;
    class?: ClassValue;
    selectedValues?: string[];
    itemCount?: number;
    excludeFromForm?: boolean;
  }

  let {
    name,
    value,
    checked,
    popular,
    "aria-label": ariaLabel,
    featureTracking,
    id, /*                                        */
    selectedValues = $bindable(),
    itemCount,
    excludeFromForm = false,
    ...rest
  }: Props = $props();

  /*                     */
  const tracking = $derived(removeStatusIf(!checked && !popular, featureTracking));

  /*                            */
  ariaLabel ||= rest.forceAriaLabel ? rest.title : undefined;

  /*                   */
  let dangerousItemCountClass = itemCount ? "" : "heureka_facetValue__dangerousZeroHits";

  function onchange({ currentTarget }: Event & { currentTarget: HTMLInputElement }) {
    selectedValues = currentTarget.checked
      ? [...(selectedValues || []), currentTarget.value]
      : selectedValues?.filter((v) => v !== currentTarget.value);
  }
</script>

{#if excludeFromForm}
  <input
    {id}
    class={[
      "js_hc_tValue ts_hc_alwaysTrack hc_facetValueInput hc_facetValueInput--noSubmission",
      dangerousItemCountClass,
      rest.class,
    ]}
    type="checkbox"
    {value}
    {checked}
    data-checked={checked}
    aria-label={ariaLabel}
    {...featureTrackingAttributes(tracking)}
    use:inputDefault
    {onchange}
  />
{:else}
  <input
    {id}
    class={["js_hc_tValue hc_facetValueInput", dangerousItemCountClass, rest.class]}
    {name}
    type="checkbox"
    {value}
    {checked}
    aria-label={ariaLabel}
    {...featureTrackingAttributes(tracking)}
    use:inputDefault
    {onchange}
  />
{/if}

<style lang="scss">
  .hc_facetValueInput--noSubmission {
    &:checked:not([data-checked="true"]) {
      background-color: var(--oc-base-color-gray-25) !important;
      ~ :global(.hc_chip__handle .hc_label) {
        font-weight: normal !important; /*                                                               */
      }
    }
  }
</style>
